import { render, staticRenderFns } from "./v-custom-consent.vue?vue&type=template&id=2f9a48b4&scoped=true&"
import script from "./v-custom-consent.vue?vue&type=script&lang=js&"
export * from "./v-custom-consent.vue?vue&type=script&lang=js&"
import style0 from "./v-custom-consent.vue?vue&type=style&index=0&id=2f9a48b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9a48b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VBtnToggle,VCol,VIcon,VRow})
